import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db, auth } from "./config/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Dashboard.css";
import LoadingScreen from "./components/LoadingScreen";
import { Card, Button } from "react-bootstrap";
import { Course, UserData } from "./types/firebase";
import FooterNav from "./components/FooterNav";
import PageHeader from "./components/PageHeader";

function Dashboard() {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  const groupID = localStorage.getItem('group');
  const courseID = localStorage.getItem('course');
  const [group, setGroup] = useState<UserData | null>(null);
  const [course, setCourse] = useState<Course | null>(null);
  const [coursesData, setCoursesData] = useState<Course[]>([]);

  useEffect(() => {
    if (loading) {
      return;
    }
    if (!user) {
      navigate("/page/login", { replace: true });
    }
  }, [user, loading, navigate]);

  useEffect(() => {
    if (groupID && courseID) {
      const groupRef = db.collection('groups').doc(groupID);

      groupRef.get().then((doc) => {
        setGroup(doc.data() as UserData);
      });
    }
  }, [groupID, courseID]);

  useEffect(() => {
    if (groupID && courseID) {
      const courseRef = db.collection('groups').doc(groupID).collection('courses').doc(courseID);
      courseRef.get().then((doc) => {
        setCourse(doc.data() as Course);
      });
    }
  }, [groupID, courseID]);

  const refreshCourses = async () => {
    if (group) {
      try {
        db.collection('groups').doc(groupID).collection('courses').onSnapshot(({ docs }) => {
          const mappedData = docs.map(d => ({ id: d.id, ...d.data() } as Course));
          setCoursesData(mappedData);
        });
      } catch (err) {
        console.log('error=====>>>>', err);
      }
    }
  };

  useEffect(() => {
    refreshCourses();
  }, [group]);

  const handleSetCurrentCourse = (id: string) => {
    localStorage.setItem('course', id);
    if (groupID) {
      const courseRef = db.collection('groups').doc(groupID).collection('courses').doc(id);
      courseRef.get().then((doc) => {
        setCourse(doc.data() as Course);
      });
    }
    navigate("/", { replace: true });
  };

  if (loading) {
    return <LoadingScreen />;
  }

  if (!group) {
    return <div>Loading group data...</div>;
  }

  if (!course) {
    return (
      <div className="dashboard">
        <h2>Select a Course</h2>
        <div className="courses-grid">
          {coursesData.map((courseData) => (
            <Card key={courseData.id} className="course-card">
              <Card.Body>
                <Card.Title>{courseData.name}</Card.Title>
                <Card.Text>
                  {courseData.city && courseData.city + ", "}
                  {courseData.state && courseData.state}
                  {courseData.province && courseData.province}
                </Card.Text>
                <Button variant="primary" onClick={() => handleSetCurrentCourse(courseData.id)}>
                  Select Course
                </Button>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      <PageHeader pageTitle='Dashboard' />
      <div className="dashboard__container w-100">
        <h2>Welcome to {course.name}</h2>
        <div className="dashboard-actions">
          <Button variant="primary" onClick={() => navigate("/page/teetimes")}>
            View Tee Times
          </Button>
          <Button variant="secondary" onClick={() => navigate("/page/myreservations")}>
            My Reservations
          </Button>
          <Button variant="info" onClick={() => navigate("/page/profile")}>
            Profile
          </Button>
        </div>
      </div>
      <FooterNav />
    </div>
  );
}

export default Dashboard;